let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("itojv")).then(() => parcelRequire('93xcu'));